export default __webpack_public_path__ + "static/media/pizza-chart.f6cf6ae8.svg";